import axios from 'axios';

// 创建一个axios实例
const instance = axios.create({
  baseURL: '/user', 
  timeout: 10000,
  withCredentials: true, // 允许跨域请求携带 cookies
});

const noBaseUrlAxios = axios.create({
  baseURL: '',
  withCredentials: true,
}); 

// 添加请求拦截器：每次请求时，检查是否有访问令牌并将其添加到请求头中
instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('access_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// 添加响应拦截器：如果访问令牌过期，使用刷新令牌获取新的访问令牌
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    // 如果访问令牌过期（401 错误），并且该请求没有重新尝试
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      
      try {
        // 调用刷新令牌的 API 获取新的访问令牌
        // refresh token 会通过 cookie 自动发送
        const response = await noBaseUrlAxios.post('/user/refresh', {}, {
          withCredentials: true // 确保请求携带 cookies
        });
        
        // 存储新的访问令牌
        const newAccessToken = response.data.access_token;
        sessionStorage.setItem('access_token', newAccessToken);
        
        // 更新原始请求的认证头
        originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
        
        // 使用新的访问令牌重试原始请求
        return axios(originalRequest);
      } catch (err) {
        console.error('刷新令牌无效，需要重新登录');
        // 清除认证信息
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('user');
        
        // 可以选择重定向到登录页面
        // window.location.href = '/login';
        
        return Promise.reject(err);
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
